import { Dispatch, SetStateAction, useCallback } from 'react';
import { useMountedRef } from './useMountedRef';

/**
 * @description dipatch called only if mounted
 * @param dispatch Dispatch unsafe while mounting
 */
export function useSafeDispatch<State>(dispatch: Dispatch<SetStateAction<State>>) {
  const mounted = useMountedRef();
  // identity of dispatch function is gaurateed to be
  // preserved by react still we do
  // [Reason] rule of hooks and idenfity of dispatch remain same durin renders
  return useCallback(
    (value: SetStateAction<State>) => {
      if (mounted.current) {
        dispatch(value);
      }
    },
    [dispatch]
  );
}
